import React, { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import axios from "axios";
import { Box, LinearProgress, Tooltip } from "@mui/material";
import { Form, Button, Card } from "react-bootstrap";
import Modal from "@mui/material/Modal";
import logo from "../image/logo.png";
import "react-toastify/dist/ReactToastify.css";
import RefreshIcon from "@mui/icons-material/Refresh";
import { encryptPassword } from "../master/userMaster/crypto";

import "./Login.css";
import LoginAnimation from "./LoginAnimation";

//API handling components
import { BASE_URL, DISABLED_MODULE } from "./../../global";
import { useDispatch } from "react-redux";
import { logOut, logIn } from "./loginSlice";
import moment from "moment";
import { useEffect } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import DeviceRegister from "./deviceRegister";
import { clearLocalStorage } from "../../utils/localstorageClear";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import { userDesignation } from "../../constants/masterUserConstants";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  height: 312,
  bgcolor: "background.paper",
  border: "2px solid cadetblue",
  padding: "20px",
  textAlign: "center",
  borderRadius: "25px",
  display: "flex",
  flexDirection: "column",
};

const data = { userName: "admin", password: "admin" };

const blockTimeConst = 15;
export const ROLES = {
  1: { name: "Calibration Authority", id: 1 },
  2: { name: "Approved Authority", id: 2 },
  3: { name: "Reviewed By", id: 3, client: true },
  4: { name: "Signed By", id: 4, client: true },
  5: { name: "Witnessed By", id: 5, client: true },
};

export const logoutUser = async () => {
  try {
    const res = await axiosWithToken.post(BASE_URL + "logout");

    // Handle success response
    console.log("Logout successful:", res.data);
  } catch (error) {
    // Handle error
    console.error("Logout failed:", error.response?.data || error.message);
  }
};

export const clearAllAppData = async (goOnline, reloadAfterClear = false) => {
  try {
    // Call API logout first
    await logoutUser();

    // Save required items before clearing
    const sqljs_dbKey = localStorage.getItem("sqljs_db");

    // Clear caches
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map((name) => caches.delete(name)));

    clearLocalStorage();

    // ✅ Set a flag before clearing
    localStorage.setItem("appDataCleared", "true");

    if (sqljs_dbKey) {
      goOnline && localStorage.setItem("isOffLine", "false");
      localStorage.setItem("sqljs_db", sqljs_dbKey);
    }

    sessionStorage.clear();

    // Clear cookies
    document.cookie.split(";").forEach((cookie) => {
      const name = cookie.split("=")[0].trim();
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
    });

    if (reloadAfterClear) {
      window.location.reload(true);
    }
  } catch (err) {
    console.error("Error clearing app data:", err);
  }
};

const getStorage = (item, json) => {
  let val = localStorage.getItem(item);
  if (json)
    try {
      val = JSON.parse(val);
    } catch {}
  return val;
};
const setStorage = (item, val, json) => {
  try {
    val = JSON.stringify(val);
  } catch {}
  return localStorage.setItem(item, val);
};

export const useGetRoleInfo = (all, type) => {
  const storage_userType = localStorage.getItem("type");
  const storage_currentRole = getStorage("currentRole", true);
  const storage_roles = (getStorage("roles", true) || []).filter((e) => e);
  const [roles, setRoles] = useState([]);
  const [currentRole, setCurrentRole] = useState({});

  useEffect(() => {
    const role_trace = async () => {
      let tRoles = all
        ? [
            ...(type
              ? Object.values(ROLES).filter((e) =>
                  storage_userType == 3 ? e.client : !e.client,
                )
              : Object.values(ROLES)),
          ]
        : storage_roles.filter((e) =>
            `${storage_userType}` === "3" ? e.client : !e.client,
          );
      let tCurrentRole = { ...storage_currentRole };
      const roleSettings = await (localStorage.getItem("isOffLine") === "true"
        ? axiosWithToken.post(
            BASE_URL + `dynamic`,
            { query: `SELECT * FROM settings WHERE keyName LIKE 'role%' AND status != -1` },
            { headers: { requestType: "fetchData" } },
          )
        : axiosWithToken.get(
            BASE_URL + `settings?_where=(keyName,like,role~)~and(status,ne,-1)`,
          ))
        .then((res) => res.data)
        .catch((err) => {
          console.log("setting fetch error : ", err);
          return false;
        });
      if (roleSettings) {
        let _settingList = {};
        roleSettings.forEach((setting) => {
          if (setting.keyName.startsWith("activeRole")) {
            _settingList[setting.keyName.split("activeRole")[1]] = {
              name: setting.value,
              id: setting.keyName.split("activeRole")[1],
            };
            if (setting.keyName.split("activeRole")[1] == currentRole?.id) {
              tCurrentRole = {
                name: setting.value,
                id: setting.keyName.split("activeRole")[1],
              };
            }
          }
        });
        tRoles = tRoles.map((e) => ({ ...e, ..._settingList[e.id] }) || e);
        tRoles = tRoles.filter((e) => e.name.toLocaleLowerCase() !== "false");
      }
      setCurrentRole(tCurrentRole);
      setStorage("currentRole", tCurrentRole);
      setRoles(tRoles);
      setStorage("roles", tRoles);
    };
    role_trace();
  }, []);

  if (type) return [...roles];
  return {
    roles,
    currentRole,
    setCurrentRole: (newCurrentRole) => {
      setCurrentRole(newCurrentRole);
      setStorage("currentRole", newCurrentRole);
    },
    setRoles: (newRoles) => {
      setRoles(newRoles);
      setStorage("roles", newRoles);
    },
  };
};

//Commented on 27/10/23
//Need to remove after few date, kept to reiew
// export const useGetAllWillBeUsedRoles = () => {
//   const [Roles, setRoles] = useState([...Object.values(ROLES).map((e) => e)]);

//   useEffect(() => {
//     let asyncFn = async () => {
//       let tmp = await axiosToken
//         .get(
//           BASE_URL + `settings?_where=(keyName,like,role~)~and(status,ne,-1)`
//         )
//         .then((res) => res.data)
//         .catch((err) => {
//           console.log("setting fetch error : ", err);
//           return false;
//         });

//       if (tmp) {
//         let _settingList = {};
//         tmp.forEach((setting) => {
//           if (setting.keyName.startsWith("activeRole")) {
//             _settingList[setting.keyName.split("activeRole")[1]] = {
//               name: setting.value,
//               id: setting.keyName.split("activeRole")[1],
//             };
//           }
//         });

//         let tRoles = Roles.map((e) => ({ ...e, ..._settingList[e.id] } || e));
//         tRoles = tRoles.filter((e) => e.name.toLocaleLowerCase() !== "false");
//         setRoles(tRoles);
//       }
//     };
//     asyncFn();
//   }, []);

//   return Roles;
// };

export const addloginEntryInAudit = (
  action,
  userId,
  dateAndTime,
  authToken,
) => {
  const payload = {
    type: "Login History",
    action,
    userId,
    change_date: dateAndTime,
  };

  // ALWAYS return a config object
  const config = { headers: { Authorization: `Bearer ${authToken}` } };
  // RETURN the axios promise
  return axios
    .post(BASE_URL + "audit_log", payload, config)
    .then(() => console.log("Audit log added:", action))
    .catch((err) => console.error("Audit log failed:", action, err));
};

function Login(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [timer, setTimer] = useState(null);
  const { setCurrentRole, setRoles } = useGetRoleInfo();
  const isOffLine = localStorage.getItem("isOffLine") === "true";
  const [loading, setLoading] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [authToken, setAuthToken] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [Otp, setOtp] = useState("");
  const [recoverPassword, setRecoverPassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [email, setEmail] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showAnimation, setShowAnimation] = useState(false);

  const handleAnimationFinish = () => {
    sessionStorage.setItem("isLoggedIn", "true");
    if (props.setIsLoggedIn) props.setIsLoggedIn(true);
    const userType = localStorage.getItem("type");
    const targetRoute = `${userType}` === "3" ? "/clientDashboard" : "/dashboard";
    window.location.hash = targetRoute;
    window.location.reload();
  };

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  const configure = async (
    _id,
    _userName,
    type,
    modules = "",
    clientId = 0,
    companies,
    branch,
    roles,
    designation,
    companyHierarchy,
    editAccess,
    disciplineID,
  ) => {
    clearLocalStorage();
    DISABLED_MODULE?.includes("emailOtpVerification") &&
      sessionStorage.setItem("isLoggedIn", true);
    localStorage.setItem("id", _id);
    localStorage.setItem("clientId", clientId);
    localStorage.setItem("userName", _userName);
    localStorage.setItem("type", type);
    localStorage.setItem("modules", modules);
    localStorage.setItem("validClients", companies);
    localStorage.setItem("branch", branch);
    localStorage.setItem("designationIds", designation);
    localStorage.setItem("companyHierarchy", companyHierarchy);
    localStorage.setItem("editAccess", editAccess);
    localStorage.setItem("disciplineID", disciplineID);

    const firstDesignation = userDesignation?.find(
      (d) => d.id === parseInt((designation || "")?.split(",")[0]),
    );
    localStorage.setItem(
      "designation",
      firstDesignation ? firstDesignation?.name : "",
    );

    let tRoles = (roles?.split(",") || [])
      .filter((e) => (`${type}` === "3" ? ROLES[e].client : !ROLES[e].client))
      .map((e) => ROLES[e]);
    const roleSettings = await (localStorage.getItem("isOffLine") === "true"
      ? axiosWithToken.post(
          BASE_URL + `dynamic`,
          { query: `SELECT * FROM settings WHERE keyName LIKE 'role%' AND status != -1` },
          { headers: { requestType: "fetchData" } },
        )
      : axiosWithToken.get(
          BASE_URL + `settings?_where=(keyName,like,role~)~and(status,ne,-1)`,
        ))
      .then((res) => res.data)
      .catch((err) => {
        console.log("setting fetch error : ", err);
        return false;
      });
    if (roleSettings) {
      let _settingList = {};
      roleSettings.forEach((setting) => {
        if (setting.keyName.startsWith("activeRole")) {
          _settingList[setting.keyName.split("activeRole")[1]] = {
            name: setting.value,
            id: setting.keyName.split("activeRole")[1],
          };
        }
      });
      tRoles = tRoles.map((e) => ({ ...e, ..._settingList[e.id] }) || e);
      tRoles = tRoles.filter((e) => e.name.toLocaleLowerCase() !== "false");
    }
    let tCurrentRole = tRoles.filter((e) => e.id == tRoles?.[0]?.id)?.[0] || {};
    setCurrentRole(tCurrentRole);
    setRoles(tRoles);
    toast.success("Login Successful!");
  };

  const renderModal = () => {
    return (
      <Modal
        open={modalOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        size="md"
      >
        <Box sx={modalStyle}>
          <div
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "24px",
            }}
          >
            <span>Kindly contact your admin to reset your credentials!</span>
          </div>
        </Box>
      </Modal>
    );
  };

  const handleVerifyCode = async () => {
    try {
      const { data } = await axiosWithToken.post(
        `${BASE_URL}email/verify-otp`,
        {
          userName,
          userEmail: email,
          otp: verificationCode,
        },
      );

      if (!data?.verification) {
        toast.error("Wrong OTP. Please try again.");
        return;
      }

      // Step 2: Recover password if needed
      if (confirmPassword) {
        try {
          await axiosWithToken.post(`${BASE_URL}recover-password`, {
            confirmPassword,
            emailId: email,
          });
        } catch (error) {
          toast.error("Password recovery failed.");
          console.error("Recover password error:", error);
          return; // Stop further execution
        }
      }

      // Step 3: Continue to login/session handling
      toast.success("Verification successful!");

      if (!authToken) {
        setRecoverPassword(false);
        window.location.reload(true);
        return;
      }

      sessionStorage.setItem("authToken", authToken);
      sessionStorage.setItem("isLoggedIn", true);
      setIsLogin(true);
      setShowAnimation(true);
    } catch (error) {
      toast.error("Invalid OTP. Please try again.");
      console.error("Verification error:", error);
    }
  };

  const sendOtpOnUserEmail = (userName, userEmail, confirmPassword) => {
    axiosWithToken
      .post(`${BASE_URL}email/send-otp`, { userName, userEmail })
      .then(async () => {})
      .catch((error) => {
        console.error("Error sending OTP:", error);
      });
  };

  const handlePasswordSubmit = async () => {
    if (!newPassword || !confirmPassword) {
      toast.error("Both password fields are required");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      sendOtpOnUserEmail(userName, email);
      toast.success("Password set! Please verify OTP sent to your email.");
      setIsLogin(true);
      setRecoverPassword(false);
    } catch (error) {
      console.error("Error fetching user email:", error);
      toast.error("Failed to retrieve user email.");
    }
  };

  const handleVerifyEmail = () => {
    if (!email || !email.includes("@")) {
      toast.error("Please enter a valid email.");
      return;
    }

    axiosWithToken
      .get(`${BASE_URL}usersView?_where=(emailId,eq,${email})`)
      .then((res) => {
        const result = res?.data;
        if (result && result.length > 0) {
          setUserName(result[0]?.userName);
          setIsVerified(true);
        } else {
          toast.error("Email is not registered.");
        }
      })
      .catch((err) => {
        console.error("Error verifying email:", err);
        toast.error("Something went wrong. Please try again.");
      });
  };

  const handleSubmit = async (e) => {
    // Check location access if locationTracking is enabled.
    if (!DISABLED_MODULE?.includes("locationTracking")) {
      if (!navigator.geolocation)
        return alert("Geolocation not supported by your browser.");

      try {
        const { state } = await navigator.permissions.query({
          name: "geolocation",
        });
        if (state === "denied")
          return alert(
            "Location access denied. Please allow location access to continue.",
          );
        if (state === "prompt") {
          const granted = await new Promise((resolve) =>
            navigator.geolocation.getCurrentPosition(
              () => resolve(true),
              () => resolve(false),
            ),
          );
          if (!granted) return alert("Please allow location access to continue.");
        }
      } catch {
        const granted = await new Promise((resolve) =>
          navigator.geolocation.getCurrentPosition(
            () => resolve(true),
            () => resolve(false),
          ),
        );
        if (!granted) return alert("Please allow location access to continue.");
      }
    }

    try {
      let res;

      if (isOffLine) {
        // Offline authentication is performed against the locally synced SQL DB.
        const encryptedPassword = await encryptPassword(password);
        res = await axiosWithToken.post(
          BASE_URL + `dynamic`,
          {
            query: `SELECT * FROM users WHERE userName = '${userName}' AND password = '${encryptedPassword}'`,
          },
          { headers: { requestType: "fetchData" } },
        );
      } else {
        res = await axiosWithToken.post(BASE_URL + `login`, {
          userName,
          password,
          ...(!DISABLED_MODULE?.includes("UULIMS") && {
            limsId: localStorage.getItem("UULIMS"),
          }),
        });
      }

      if (!res.data || (isOffLine && res.data.length === 0)) {
        toast.error("Incorrect Username / password");
        setIsLoading(false);
        return;
      }

      const userObj = isOffLine ? res.data?.[0] : res.data?.user;

      if (userObj?.userStatus !== 1) {
        toast.error("User is not Active");
        setTimeout(() => window.location.reload(), 2500);
        return;
      }

      const authToken = isOffLine ? "offline-session" : res.data?.token;
      const emailId = userObj?.emailId || "";

      setAuthToken(authToken);
      setEmail(emailId);

      // Online mode keeps the existing email OTP verification flow.
      // Offline mode must not depend on the online email service.
      if (!isOffLine && !emailId && !DISABLED_MODULE?.includes("emailOtpVerification")) {
        toast.error(
          "Email is not available for this user. Please add an email first.",
        );
        setIsLoading(false);
        return;
      }

      sessionStorage.setItem("authToken", authToken);
      sessionStorage.setItem("logInUser", userObj?.userName || userName);
      sessionStorage.setItem("chatBoatAPI", BASE_URL);

      if (!isOffLine && !DISABLED_MODULE?.includes("emailOtpVerification")) {
        sendOtpOnUserEmail(userObj?.userName, userObj?.emailId);
      }

      // Get the user's active client assignments. Offline uses the local SQL DB.
      const SQLQuery = {
        query: `SELECT * FROM userClientAssign WHERE userId = ${
          userObj?.id
        } AND endDate > '${moment(new Date()).format("YYYY-MM-DD")}'`,
      };

      let res2;
      if (isOffLine) {
        res2 = await axiosWithToken.post(BASE_URL + `dynamic`, SQLQuery, {
          headers: { requestType: "fetchData" },
        });
      } else {
        res2 = await axiosWithToken.get(
          BASE_URL +
            `userClientAssign?_where=(userId,eq,${
              userObj?.id
            })~and(endDate,gt,${moment(new Date()).format("YYYY-MM-DD")})`,
          !DISABLED_MODULE?.includes("emailOtpVerification") && {
            headers: { Authorization: `Bearer ${authToken}` },
          },
        );
      }

      setIsLogin(true);

      await configure(
        userObj?.id,
        userObj?.userName,
        userObj?.type,
        userObj?.modules,
        userObj?.clientId,
        (res2?.data || []).map((e) => e.companyId).join(","),
        userObj?.branch,
        userObj?.roles || null,
        userObj?.designation,
        userObj?.companyHierarchy,
        userObj?.editAccess,
        userObj?.disciplineID,
      );

      // Audit logging is an online API operation, so skip it in offline mode.
      if (!isOffLine) {
        await addloginEntryInAudit(
          "login",
          userObj?.id,
          moment().format("YYYY-MM-DD HH:mm:ss"),
          authToken,
        );
      }

      if ("caches" in window) {
        caches.keys().then((cacheNames) => {
          cacheNames.forEach((cacheName) => caches.delete(cacheName));
        });
      }

      setIsLoading(false);

      // Offline login and disabled-OTP online login can continue immediately.
      // Online OTP-enabled login waits for handleVerifyCode().
      if (isOffLine || DISABLED_MODULE?.includes("emailOtpVerification")) {
        sessionStorage.setItem("isLoggedIn", "true");
        setShowAnimation(true);
      }
    } catch (error) {
      const errorMsg = error?.response?.data?.error || "";
      console.log("errorMsg", errorMsg);

      if (errorMsg.toLowerCase().includes("device not register")) {
        toast.error("Your device is not registered contact to BFI Team.");
      } else if (errorMsg.toLowerCase().includes("already logged in")) {
        toast.error("Already logged in on another device. Please logout first.");
      } else {
        toast.error("Incorrect Username / password");
        setError(errorMsg || "Incorrect Username / password");
        const falseLoginCount = localStorage.getItem("loginCount") || 0;
        localStorage.setItem("loginCount", Number(falseLoginCount) + 1);
        if (Number(falseLoginCount) === 2) {
          const blockTime = Date.now() + blockTimeConst * 60 * 1000;
          localStorage.setItem("blockTimer", blockTime);
        }
        checkTimer();
      }

      setIsLoading(false);
    }
  };
  const checkTimer = () => {
    let blockCount = Number(localStorage.getItem("loginCount")) || 0;
    if (blockCount > 2) {
      let blockTime =
        ((Number(localStorage.getItem("blockTimer")) || 0) - Date.now()) / 1000;
      blockTime = blockTime > 0 ? blockTime : 0;
      if (blockTime && !timer)
        setInterval(() => {
          checkTimer();
        }, 1000);
      if (blockTime)
        setError(
          `Please try again after ${parseInt(
            `${blockTime / 60}`,
          )} minutes and ${parseInt(`${blockTime % 60}`)} seconds ${
            blockCount < 3 ? `(${3 - blockCount} tries remaining)` : ""
          }`,
        );
      else {
        localStorage.setItem("loginCount", 0);
        localStorage.setItem("blockTimer", -1);
        if (timer) clearInterval(timer);
        setError("");
      }
    } else if (blockCount > 0) {
      setError(
        `Incorrect Username / password \n  ${
          blockCount < 3 ? `(${3 - blockCount} tries remaining)` : ""
        }`,
      );
    } else setError("");
  };

  useEffect(() => {
    checkTimer();
    return () => {
      if (timer) clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    const isDataCleared = localStorage.getItem("appDataCleared");
    if (!isDataCleared) {
      clearAllAppData();
    }
  }, []);

  return (
    <>
      {showAnimation && <LoginAnimation onFinish={handleAnimationFinish} />}
      {!showAnimation && (
        <div className="limiter">
        <div
          style={{
            position: "fixed",
            top: 16,
            right: 16,
            zIndex: 9999,
          }}
        >
          <button
            onClick={async () => {
              setLoading(true);
              try {
                await clearAllAppData(undefined, true);
              } finally {
                setLoading(false);
              }
            }}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              backgroundColor: "#1976d2",
              color: "#fff",
              border: "none",
              padding: "10px 16px",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "bold",
              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            }}
          >
            <RefreshIcon
              style={{
                fontSize: "18px",
                animation: loading ? "spin 1s linear infinite" : "none",
              }}
            />
          </button>
        </div>
        <div className="container-login100">
          <div className="wrap-login100">
            <div className="login100-pic js-tilt" data-tilt>
              <img className="" src={logo} alt="IMG" />
              <p className="login-lims-text">
                Laboratory Information
                <br />
                Management System
              </p>
            </div>

            {recoverPassword ? (
              // ✅ Recover Password UI
              <div className="login100-form validate-form">
                <span className="login100-form-title">Recover Password</span>
                <p className="login-subtitle">
                  Set a new password for your account
                </p>

                {/* Email field */}
                <div
                  className="wrap-input100 validate-input input-group-focus"
                  style={{ position: "relative" }}
                >
                  <label className="login-label">Email Address</label>
                  <span className="symbol-input100">
                    <PersonOutlineIcon style={{ fontSize: "20px" }} />
                  </span>
                  <input
                    className="input100"
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    value={email || ""}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <span className="focus-input100"></span>
                </div>

                {/* Password Fields - Show only after verification */}
                {isVerified && (
                  <>
                    <div
                      className="wrap-input100 validate-input input-group-focus"
                      style={{ position: "relative" }}
                    >
                      <label className="login-label">New Password</label>
                      <span className="symbol-input100">
                        <LockOutlinedIcon style={{ fontSize: "20px" }} />
                      </span>
                      <input
                        className="input100"
                        type={showPassword ? "text" : "password"}
                        name="newPassword"
                        placeholder="Enter new password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                      <span className="focus-input100"></span>
                      <span
                        className="symbol-input100-right"
                        onClick={() => setShowPassword((prev) => !prev)}
                      >
                        {showPassword ? (
                          <VisibilityOffIcon />
                        ) : (
                          <VisibilityIcon />
                        )}
                      </span>
                    </div>

                    <div
                      className="wrap-input100 validate-input input-group-focus"
                      style={{ position: "relative" }}
                    >
                      <label className="login-label">Confirm Password</label>
                      <span className="symbol-input100">
                        <LockOutlinedIcon style={{ fontSize: "20px" }} />
                      </span>
                      <input
                        className="input100"
                        type={showConfirmPassword ? "text" : "password"}
                        name="confirmPassword"
                        placeholder="Confirm new password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                      <span className="focus-input100"></span>
                      <span
                        className="symbol-input100-right"
                        onClick={() => setShowConfirmPassword((prev) => !prev)}
                      >
                        {showConfirmPassword ? (
                          <VisibilityOffIcon />
                        ) : (
                          <VisibilityIcon />
                        )}
                      </span>
                    </div>
                  </>
                )}

                {/* Button — Next or Continue */}
                <div className="container-login100-form-btn">
                  {!isVerified ? (
                    <button
                      className="login100-form-btn"
                      onClick={handleVerifyEmail}
                      disabled={!email}
                    >
                      Next
                    </button>
                  ) : (
                    <button
                      className="login100-form-btn"
                      onClick={handlePasswordSubmit}
                      disabled={
                        !newPassword ||
                        !confirmPassword ||
                        newPassword !== confirmPassword
                      }
                    >
                      Continue
                    </button>
                  )}
                </div>

                <div
                  className="text-center p-t-12"
                  style={{ marginTop: "10px" }}
                >
                  <span className="txt1">Remember it? </span>
                  <button
                    className="txt2 login-forgot-btn"
                    style={{ backgroundColor: "#0000" }}
                    onClick={() => setRecoverPassword(false)}
                  >
                    Back to Login
                  </button>
                </div>
              </div>
            ) : !DISABLED_MODULE?.includes("emailOtpVerification") &&
              isLogin ? (
              <div className="login100-form validate-form">
                <span className="login100-form-title">Verify it’s you</span>

                <p style={{ textAlign: "center", marginBottom: "20px" }}>
                  A verification code has been sent to your email address ending
                  with{" "}
                  <strong style={{ color: "black" }}>
                    {email
                      ? `${email.slice(0, 3)}***@${email.split("@")[1]}`
                      : ""}
                  </strong>
                  .
                </p>

                <div
                  className="wrap-input100 validate-input"
                  data-validate="6-digit code is required"
                >
                  <input
                    className="input100"
                    type="text"
                    name="code"
                    maxLength={6}
                    placeholder="6-digit code"
                    value={verificationCode}
                    onChange={(e) => setVerificationCode(e.target.value)}
                  />
                  <span className="focus-input100"></span>
                </div>

                <div className="container-login100-form-btn">
                  <button
                    className="login100-form-btn"
                    onClick={handleVerifyCode}
                    // disabled={verificationCode.length !== 6}
                  >
                    Verify Code
                  </button>
                </div>

                <div className="text-center p-t-12">
                  <span className="txt1">Can't verify? </span>
                  <button
                    className="txt2"
                    style={{ backgroundColor: "transparent" }}
                    // onClick={handleRecoverAccount}
                  >
                    Recover your account.
                  </button>
                </div>

                <p
                  style={{
                    fontSize: "12px",
                    textAlign: "center",
                    marginTop: "10px",
                  }}
                >
                  <strong>Note:</strong> All of these verification methods will
                  be removed after successful recovery.
                </p>
              </div>
            ) : (
              <div className="login100-form validate-form">
                <span className="login100-form-title">Welcome to LIMS</span>
                <p className="login-subtitle">Please sign in to continue</p>

                <div
                  className="wrap-input100 validate-input input-group-focus"
                  data-validate="Valid email is required: ex@abc.xyz"
                  style={{ position: "relative" }}
                >
                  <label className="login-label">Username</label>
                  <span className="symbol-input100">
                    <PersonOutlineIcon style={{ fontSize: "20px" }} />
                  </span>
                  <input
                    className="input100"
                    type="text"
                    name="email"
                    placeholder="Enter your username"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    disabled={
                      Number(localStorage.getItem("loginCount") || 0) === 3
                    }
                  />
                  <span className="focus-input100"></span>
                </div>

                <div
                  className="wrap-input100 validate-input input-group-focus"
                  data-validate="Password is required"
                  style={{ position: "relative" }}
                >
                  <label className="login-label">Password</label>
                  <span className="symbol-input100">
                    <LockOutlinedIcon style={{ fontSize: "20px" }} />
                  </span>
                  <input
                    className="input100"
                    type={showPassword ? "text" : "password"}
                    name="pass"
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={
                      Number(localStorage.getItem("loginCount") || 0) === 3
                    }
                  />
                  <span
                    className="symbol-input100-right"
                    onClick={() => setShowPassword((prev) => !prev)}
                    style={{ cursor: "pointer" }}
                  >
                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </span>
                </div>
                <span
                  style={{
                    color: "red",
                    fontSize: "14px",
                    display: "block",
                    textAlign: "center",
                    marginBottom: "4px",
                  }}
                >
                  {error}
                </span>
                <div className="login-forgot-row">
                  <button
                    className="txt2 login-forgot-btn"
                    style={{ backgroundColor: "#0000", color: "#3B5BDB" }}
                    onClick={(e) => setRecoverPassword(true)}
                  >
                    Forgot Password?
                  </button>
                </div>
                <div className="container-login100-form-btn">
                  <button
                    className="login100-form-btn"
                    onClick={() => {
                      setIsLoading(true);
                      handleSubmit();
                    }}
                    disabled={
                      isLoading ||
                      localStorage.getItem("blockTimer") > Date.now() ||
                      (Number(localStorage.getItem("loginCount")) || 0) === 3
                    }
                  >
                    Sign In
                  </button>
                </div>
                <div
                  className="text-center p-t-12"
                  style={{ marginTop: "10px" }}
                >
                  <span className="txt1">Need help? </span>
                  <a
                    href="mailto:Info@bfiinfotech.co.in"
                    className="txt2"
                    style={{ color: "#3B5BDB", textDecoration: "none" }}
                  >
                    Contact Support
                  </a>
                </div>
                {!DISABLED_MODULE?.includes("UULIMS") && <DeviceRegister />}
              </div>
            )}
          </div>
        </div>
        </div>
      )}
      {renderModal()}
    </>
  );
}

export default Login;